<template>
  <v-list-item
    v-if="routeAllowed"
    class="vertical-nav-menu-link"
    v-bind="$attrs"
    active-class="v-list-item--active admin-nav-link--active"
  >
    <v-list-item-icon>
      <v-icon
        :class="{'alternate-icon-small': !icon}"
        class="mx-auto"
      >
        {{ icon || alternateIcon }}
      </v-icon>
    </v-list-item-icon>

    <v-list-item-title>
      {{ title }}
    </v-list-item-title>
  </v-list-item>
</template>

<script>
import { mdiCheckboxBlankCircleOutline } from '@mdi/js'
import canAccessScope from '@/utils/panelPermissions'

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    routeAllowed() {
      if (!this.$attrs.to) return true
      const { route } = this.$router.resolve(this.$attrs.to, this.$route)

      return Boolean(route.matched.length) && canAccessScope(route.meta.authScope)
    },
  },
  setup() {
    return {
      alternateIcon: mdiCheckboxBlankCircleOutline,
    }
  },
}
</script>

<style lang="scss" scoped>
.alternate-icon-small {
  font-size: 14px;
  height: 14px;
  width: 14px;
}
</style>
